import { useEffect, useRef } from "react";
import "./index.css";

// Swapping values around for a better visual effect
const dataMap = {
  0: 15,
  1: 10,
  2: 8,
  3: 9,
  4: 6,
  5: 5,
  6: 2,
  7: 1,
  8: 0,
  9: 4,
  10: 3,
  11: 7,
  12: 11,
  13: 12,
  14: 13,
  15: 14,
};

const AudioVisualizer = ({ audioStream }) => {
  const audioVisualizerRef = useRef(null);
  const analyserRef = useRef(null);

  const visualValueCount = 16;
  let visualElements;

  const processFrame = (data) => {
    const values = Object.values(data);
    let i;
    for (i = 0; i < visualValueCount; ++i) {
      const value = values[dataMap[i]] / 255;
      const elmStyles = visualElements[i].style;
      if (value > 0.45) {
        elmStyles.transform = `scaleY( ${Math.max(0.01, value)} )`;
      } else {
        elmStyles.transform = `scaleY( ${0.01} )`;
      }
      elmStyles.opacity = 1;
    }
  };

  const initDOM = () => {
    audioVisualizerRef.current.innerHTML = "";
    let i;
    for (i = 0; i < visualValueCount; ++i) {
      const elm = document.createElement("div");
      audioVisualizerRef.current.appendChild(elm);
    }

    visualElements = document.querySelectorAll("span div");
  };

  const initRenderLoop = (frequencyData) => {
    const renderFrame = () => {
      analyserRef.current.getByteFrequencyData(frequencyData);
      processFrame(frequencyData);

      requestAnimationFrame(renderFrame);
    };
    requestAnimationFrame(renderFrame);
  };

  const initAudioFrequencyData = () => {
    const audioContext = new AudioContext();
    analyserRef.current = audioContext.createAnalyser();
    analyserRef.current.smoothingTimeConstant = 0.5;
    analyserRef.current.fftSize = 32;
    const source = audioContext.createMediaStreamSource(audioStream);
    source.connect(analyserRef.current);
    const frequencyData = new Uint8Array(analyserRef.current.frequencyBinCount);
    return frequencyData;
  };

  useEffect(() => {
    const frequencyData = initAudioFrequencyData();
    initDOM();
    initRenderLoop(frequencyData);
  }, []);

  return (
    <div className="audioVisualizerWrapper">
      <span className="visualizerContainer" ref={audioVisualizerRef}></span>
    </div>
  );
};

export default AudioVisualizer;
